import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { ComponentAdaperLight } from "../../class/adapters/component-adapter-light";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { IconHelper } from "../../class/icon-helper";
import { IonButton, IonIcon } from "@ionic/angular";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";

@Component({
    selector: "app-widget-light",
    templateUrl: "./widget-light.component.html",
    styleUrls: ["./widget-light.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent]
})

/**
 * Counter entry componet
 */
export class WidgetLightComponent extends WidgetParent<ComponentAdaperLight> {
  private _iconLightOn = "";
  private _iconLightOff = "";

  public iconLightState: string = "";

  constructor() {
    super();

    this._iconLightOff = IconHelper.getIconsForLightComponent().off;
    this._iconLightOn = IconHelper.getIconsForLightComponent().on;

    this.iconLightState = this._iconLightOff;
  }

  /**
   * Add class "turn-on" to button if light is on
   * @returns boolean
   */
  public toggleClassForButton(): boolean {
    return this.iconLightState === this._iconLightOn ? true : false;
  }

  /**
   * When the button is clicked turn on/off light
   */
  public onClickSwitchLight(): void {
    this.switchLight();
  }

  /**
   * Switch light on/off and send command via mqtt
   */
  private switchLight(): void {
    if (this.componentAdapter.TurnOnOffCommand) {
      const instanceGUID: string =
        this.componentAdapter.TurnOnOffCommand.instanceGUID;
      const address: string = this.componentAdapter.TurnOnOffCommand.address;

      // Send command to turn on/off the light using VALUE NOT command
      this.sendAddressCommand(instanceGUID, address, "VALUE NOT");
    }
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void { }

  protected onSmartComponentErrorLoading(): void { }

  protected onComponentDestroy(): void { }

  protected onSmartComponentSuccessLoaded(): void | boolean {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdaperLight
    );

    this.titleWidget = this.componentAdapter.Name;

    //If component title is empty show error loading component
    if (!this.titleWidget) {
      return this._errorLoading = true;
    }
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string
  ): void {
    if (this.componentAdapter.TurnOnOffState) {
      // Update the icon light state based on the value of the address
      if (
        instanceGUID === this.componentAdapter.TurnOnOffState.instanceGUID &&
        address === this.componentAdapter.TurnOnOffState.address
      ) {
        if (value === "1") {
          this.iconLightState = this._iconLightOn;
        } else {
          this.iconLightState = this._iconLightOff;
        }
      }
    }
  }
}
